let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l4bde")).then(() => parcelRequire('kz3Lh'));